module.exports = __webpack_public_path__ + "img/perk-joy.9b85e730.png";